<div class="content-grid-wrapper h-full">
  <div class="col-span-10">
    <app-content-header [title]="dashboardHeaderTitle" titleClass="text-primaryText"
      [description]="'CLIENTS.DASHBOARD.DESCRIPTION' | translate"></app-content-header>
  </div>

  <div class="col-span-10 grid grid-cols-12 gap-(--spacing-layout-l)">
    <app-c-stats-widget class="contents" />
    @if (aiFeatureEnabled) {
    <app-c-ai-summary class="col-span-12" />
    }
    <div class="col-span-12 flex justify-between items-center">
      <span class="text-heading-small text-primaryText">
        Featured Investment Opportunities
      </span>
      <div class="">
        <app-tag [value]="featuredDealsTotal() + ' deals shared'" severity="primary" />
      </div>
    </div>
    <div class="col-span-12">
      <app-paginated-grid [items]="featuredDealsItems()" [loading]="featuredDealsLoading()"
        [emptyMessage]="getFeaturedDealsEmptyMessage()" [totalRecords]="featuredDealsTotal()"
        [first]="featuredDealsFirst()" [rows]="featuredDealsPageSize()" [rowsPerPageOptions]="[4, 10, 20, 30]"
        [trackByKey]="'clientDealId'" [skeletonCount]="4" (pageChange)="onFeaturedDealsPageChange($event)" [paginator]="false">
        <ng-template let-deal let-index="index">
          <app-card rootClass="border border-primaryBorder h-full" bodyClass="h-full" contentClass="h-full flex flex-col">
            <div class="flex flex-col flex-1">
              <div class="p-5 flex justify-between items-start shrink-0">
                <div class="flex flex-col justify-center">
                  <span class="text-subheading-large text-headingText">
                    {{ deal.title }}
                  </span>
                  <div class="flex items-center gap-2">
                    <svg-icon [src]="getAssetClassIcon(deal.assetClass)" svgClass="w-4 h-4"></svg-icon>
                    <span class="text-body-large text-bodyText">
                      {{ deal.categories.join(' | ') }}
                    </span>
                  </div>
                </div>
                <app-tag [value]="deal.tag" [severity]="deal.tagSeverity" />
              </div>
              <div class="p-5 flex flex-col gap-4 pt-0 flex-1">
                <div class="flex flex-col justify-center gap-2">
                  <span class="text-subheading-medium text-headingText">{{ deal.remainingAllocation | number:'1.0-2' }}% remaining
                    allocation</span>
                  <app-progress-bar [value]="deal.progressValue" />
                </div>
                <div>
                  <app-stepper
                    [steps]="getDealProcessStepsForDeal(deal)"
                    [currentStep]="deal.stepperCurrentStep"
                    [errorStepIndex]="deal.stepperErrorStepIndex"
                    [completedStepIndices]="deal.stepperCompletedStepIndices"
                    [enableBounce]="shouldEnableInvestmentJourneyStepperBounce(deal)"
                  />
                </div>
                <app-divider [style]="{margin: '0px'}" />
                <div class="flex gap-2">
                  <div class="flex flex-col flex-1 gap-2">
                    <span class="text-subheading-medium text-headingText">Min Investment:</span>
                    <app-currency-display
                      class="text-body-large text-bodyText"
                      [value]="deal.minimumAmountUsd"
                      [currencyCode]="deal.currency || 'USD'"
                      [compact]="true"
                    />
                  </div>
                  <div class="flex flex-col flex-1 gap-2">
                    <span class="text-subheading-medium text-headingText">Target Return:</span>
                    <span class="text-body-large text-bodyText">{{ deal.targetReturn }}</span>
                  </div>
                  <div class="flex flex-col flex-1 gap-2">
                    <span class="text-subheading-medium text-headingText">Duration:</span>
                    <span class="text-body-large text-bodyText">{{ deal.duration }}</span>
                  </div>
                  <!-- Risk Level field hidden
                  <div class="flex flex-col flex-1 gap-2">
                    <span class="text-subheading-medium text-headingText">Risk Level:</span>
                    <span class="text-body-large text-bodyText">{{ deal.riskLevel }}</span>
                  </div>
                  -->
                </div>
                <div class="flex flex-col gap-2">
                  <span class="text-subheading-medium text-headingText">Description:</span>
                  <span class="text-body-large text-bodyText">{{ deal.description }}</span>
                </div>
                <div class="flex flex-col gap-2 flex-1">
                  @if (deal.sections && deal.sections?.some(section => section.title === 'Why Invest?')) {
    
                    @for (section of deal.sections; track section) {
                      @if (section.title === 'Why Invest?') {
                        <span class="text-subheading-medium text-headingText">
                          {{ section.title }}
                        </span>
                        <div id="why-invest" class="rich-text-content" [innerHTML]="section.content"></div>
                      }
                    }
                
                  }
                </div>
                @if(deal.clientDealStatus){
                  @if( (deal.clientDealStatus === ClientDealStatusV2.EXPRESSED_INTEREST || deal.clientDealStatus === ClientDealStatusV2.CLOSING) && deal.clientInterest){
                      <div class="flex justify-between bg-brandLimeBackground py-2.5 px-5 rounded-12">
                          <div class="flex items-center gap-2">
                              <svg-icon src="/icons/briefcase-deal.svg" svgClass="w-5 h-5 text-drawer-header-text"></svg-icon>
                              <span class="text-subheading-medium text-primaryText">Interest Expressed</span>
                          </div>
                          <div>
                              <span class="text-subheading-medium text-headingText">Amount:</span>
                              <app-currency-display
                                class="text-body-large text-primaryText"
                                [value]="deal.clientInterest.interestAmount"
                                [currencyCode]="deal.currency || 'USD'"
                                [compact]="true"
                              />
                          </div>
                          <div>
                              <span class="text-subheading-medium text-headingText">Submitted:</span>
                              <span class="text-body-large text-primaryText">{{deal.clientInterest.expressedInterestAt | date:'dd/MM/yyyy'}}</span>
                          </div>
                      </div>
                  } 
                  @if( deal.clientDealStatus === ClientDealStatusV2.MISSED){
                      <div class="flex justify-between bg-brandSecondaryBackground py-2.5 px-5 rounded-12">
                          <div class="flex items-center gap-2">
                              <span class="text-subheading-medium text-primaryText">This opportunity is closed for investment</span>
                          </div>
                      </div>
                  }
                   @if( deal.clientDealStatus === ClientDealStatusV2.DECLINED){
                      <div class="flex justify-between bg-brandLimeBackground py-2.5 px-5 rounded-12">
                          <div class="flex items-center gap-2">
                              <span class="text-subheading-medium text-primaryText">You are still able to invest in this opportunity</span>
                          </div>
                      </div>
                  }
              }
                <div class="flex gap-4">
                  <a [routerLink]="['/client/deal-details', deal.clientDealId]" [queryParams]="{ dealsTab: 'live' }"
                    class="flex-1">
                    <app-button [label]="'View Details'" [styleClass]="'w-full'" endIcon="/icons/eye.svg" variant="secondary" />
                  </a>
                  @if (shouldShowExpressInterestButton(deal.clientDealStatus)) {
                  <app-button [label]="'Express Interest'" [styleClass]="'w-full'" endIcon="/icons/briefcase-deal.svg"
                    variant="primary" class="flex-1" [enableBounce]="shouldEnableInvestmentJourneyStepperBounce(deal)"
                    (onClick)="onExpressInterest(deal)" />
                  } @else {
                    @if (canShowRequestKycButton(deal)) {
                    <app-button [label]="kycActionLabel(deal)" [styleClass]="'w-full'" endIcon="/icons/upload.svg"
                      variant="primary" class="flex-1" [enableBounce]="shouldEnableInvestmentJourneyStepperBounce(deal)"
                      (onClick)="openRequestKycDrawer(deal)" />
                    } @else {
                      @if (deal?.clientDealStatus === 1 && deal?.minThresholdMet !== true) {
                        <app-button [label]="'Withdraw Interest'" [styleClass]="'w-full'" endIcon="/icons/cross.svg"
                          variant="secondary" class="flex-1" (onClick)="onClientWithdrawInterest(deal)" />
                      }
                    }
                  }
                </div>
                @if (deal.rmNote) {
                <div class="flex gap-2 bg-(--drawer-bg) py-2.5 px-5 rounded-12">
                  <svg-icon src="/icons/message-alert.svg" svgClass="w-5 h-5 text-drawer-header-text"></svg-icon>
                  <div class="flex flex-col gap-1">
                    <span class="text-body-large text-headingText">{{ deal.rmNote }}</span>
                  </div>
                </div>
                } 
              </div>
            </div>
          </app-card>
        </ng-template>
      </app-paginated-grid>
    </div>
    <div class="col-span-12 flex justify-between items-center">
      <span class="text-heading-small text-primaryText">
        My Portfolio
      </span>
    </div>
    <div class="col-span-12 xl:col-span-12">
      <app-card>
        <div class="flex flex-col">
          <div class="text-subheading-large text-headingText p-5 pt-4 ">Investment by Asset Class</div>
          <div class="p-5">
            @if (assetClassChartState().loading && !assetClassChartState().data) {
              <div class="flex items-center justify-between gap-3 w-full h-full min-h-[200px]">
                <div class="flex-1">
                  <p-skeleton shape="circle" size="15rem" />
                </div>
                <div class=" flex-1 flex flex-col gap-2">
                  <p-skeleton height="0.875rem" width="100%" />
                  <p-skeleton height="0.875rem" width="100%" />
                  <p-skeleton height="0.875rem" width="100%" />
                  <p-skeleton height="0.875rem" width="100%" />
                </div>
              </div>
            } @else if (assetClassChartState().error) {
              <div class="flex items-center justify-center min-h-[200px] text-bodyText">Failed to load investment by asset class.</div>
            } @else if (!(assetClassChartState().data?.slices?.length)) {
              <div class="flex items-center justify-center min-h-[200px] text-bodyText">No data available</div>
            } @else {
            <app-doughnut-chart [data]="doughnutChartData"></app-doughnut-chart>
            }
          </div>
        </div>
      </app-card>
    </div>
  </div>
</div>

@if (selectedDealForExpressInterest(); as deal) {
  
  <app-express-interest-dialog
    [visible]="showExpressInterestDialog()"
    (visibleChange)="onExpressInterestDialogVisibleChange($event)"
    [dealId]="deal.id"
    [clientDealId]="deal.clientDealId"
    [dealName]="deal.title"
    [minAmount]="deal.minimumAmountUsd"
    [currency]="deal.currency"
    (onSubmitSuccess)="onExpressInterestSuccess()"
  />
}

<app-drawer
  drawerId="clientDashboardKycRequestDrawer"
  [header]="'Submit KYC'"
  [modal]="true"
  [closable]="true"
  [styleClass]="'!w-full sm:!w-[40rem]'"
  (onHide)="closeRequestKycDrawer()"
>
  @if (selectedDealForKyc(); as deal) {
  <div class="flex flex-col min-h-full px-5 py-2.5 gap-4">
    <app-stepper [steps]="kycSteps" [currentStep]="kycStep()" />

    <div class="flex flex-col bg-white rounded-12 p-5 gap-4">
      @if (kycStep() === 0) {
        <div class="flex flex-col gap-2">
          <span class="text-subheading-medium text-headingText">Select KYC type</span>
          <p-select
            [ngModel]="selectedKycType()"
            (ngModelChange)="selectedKycType.set($event)"
            [options]="kycTypeOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="KYC type"
            styleClass="w-full"
          />
        </div>
        <div class="flex gap-3 justify-end">
          <app-button variant="secondary" [label]="'ACTIONS.CANCEL' | translate" (onClick)="closeRequestKycDrawer()" />
          <app-button variant="primary" [label]="'Continue'" [disabled]="kycSessionLoading()" [loading]="kycSessionLoading()" (onClick)="createKycSession()" />
        </div>
      }

      @if (kycStep() === 1) {
        @if (kycSessionLoading()) {
          <p-skeleton width="100%" height="220px"></p-skeleton>
        } @else if (kycSession(); as session) {
          <div class="flex items-center justify-between">
            <div class="text-subheading-medium text-headingText">Required documents</div>
          </div>

          <div class="flex flex-col gap-4">
            @for (req of session.requirements; track req.id) {
              <div class="border border-surface-200 rounded-xl p-4 flex flex-col gap-3">
                <div class="flex items-center justify-between gap-3">
                  <div class="flex flex-col">
                    <div class="text-subheading-medium text-headingText">
                      {{ requirementTitle(req) }}
                      @if (isClientKycRequirementMandatory(req)) { <span class="text-error">*</span> }
                    </div>
                    <div class="text-caption text-secondaryLabel">Upload PDF/Word files</div>
                  </div>
                  @if (kycUploadLoadingByReq()[req.id]) {
                    <span class="text-caption text-secondaryLabel">Uploading…</span>
                  }
                </div>

                  <app-file-uploader
                    #kycReqUploader
                    [multiple]="true"
                    [isLoading]="kycUploadLoadingByReq()[req.id]"
                    [disabled]="kycUploadLoadingByReq()[req.id]"
                    accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    (filesChange)="uploadRequirementFiles(req, $event, kycReqUploader)"
                />

                <div class="flex flex-col gap-2">
                  <div class="text-subheading-small text-headingText">Uploaded files</div>
                  @if ((req.files ?? []).length) {
                    <ul class="space-y-3">
                      @for (f of req.files; track f.id) {
                        <li
                          class="group flex flex-row items-center gap-4 justify-between p-4 border border-surface-200 rounded-xl transition"
                          [class.cursor-pointer]="f.previewUrl"
                          [class.hover:bg-surface-50]="f.previewUrl"
                          [class.hover:border-primary]="f.previewUrl"
                          [class.hover:shadow-sm]="f.previewUrl"
                          (click)="f.previewUrl && openKycFilePreview(f.previewUrl, f.fileName)"
                          role="button"
                          [attr.tabindex]="f.previewUrl ? 0 : null"
                          (keydown.enter)="f.previewUrl && openKycFilePreview(f.previewUrl, f.fileName)"
                        >
                          <div class="flex items-center gap-4 min-w-0 flex-1">
                            <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-surface-100 group-hover:bg-primary/10 shrink-0 transition">
                              <i [class]="kycFileTypeIcon(f.fileName)" class="text-lg text-secondaryLabel group-hover:text-primary transition"></i>
                            </div>
                            <div class="min-w-0 flex-1">
                              <p class="text-subheading-medium text-headingText truncate group-hover:text-primary transition">{{ f.fileName }}</p>
                              @if (f.previewUrl) {
                                <p class="text-caption text-secondaryLabel mt-0.5">{{ 'GENERIC.CLICK_TO_PREVIEW' | translate }}</p>
                              }
                            </div>
                          </div>
                          <div class="flex items-center gap-2 shrink-0">
                            @if (f.previewUrl) {
                              <span class="hidden group-hover:flex items-center gap-1 text-xs text-primary font-medium">
                                <i class="pi pi-eye text-sm"></i>
                                {{ 'GENERIC.PREVIEW' | translate }}
                              </span>
                              <i class="pi pi-chevron-right text-sm text-surface-300 group-hover:text-primary transition"></i>
                            }
                            @if (canDeleteKycFile()) {
                            <button
                              type="button"
                              class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-secondaryLabel hover:text-red-600 hover:bg-red-50"
                              [attr.aria-label]="'ADMIN.SHARED_DEALS_TAB.CLIENT_KYC_DELETE_DOCUMENT' | translate"
                              (click)="requestDeleteKycFile(req, f, $event)"
                            >
                              <i class="pi pi-trash"></i>
                            </button>
                            }
                          </div>
                        </li>
                      }
                    </ul>
                  } @else {
                    <div class="text-bodyText text-secondaryLabel">No files uploaded yet.</div>
                  }
                </div>
              </div>
            }
          </div>

          <div class="pt-2 flex gap-3 justify-end">
            <app-button variant="secondary" [label]="'ACTIONS.CANCEL' | translate" (onClick)="closeRequestKycDrawer()" />
            <app-button variant="primary" [label]="'Submit'" [disabled]="kycSubmitting() || !canSubmitKyc()" [loading]="kycSubmitting()" (onClick)="submitKyc()" />
          </div>
        } @else {
          <div class="text-bodyText text-secondaryLabel">Unable to load session.</div>
        }
      }
    </div>
  </div>
  }
</app-drawer>

<app-confirmation-dialog
  [visible]="!!kycFileDeleteTarget()"
  (visibleChange)="!$event && cancelDeleteKycFile()"
  [header]="'ADMIN.SHARED_DEALS_TAB.CLIENT_KYC_DELETE_DOCUMENT' | translate"
  [title]="'ADMIN.SHARED_DEALS_TAB.CLIENT_KYC_DELETE_DOCUMENT_CONFIRM' | translate"
  [loading]="kycFileDeleteLoading()"
  (confirm)="confirmDeleteKycFile()"
  (cancel)="cancelDeleteKycFile()"
/>

<app-doc-preview-dialog
  [visible]="kycPreviewVisible()"
  (visibleChange)="kycPreviewVisible.set($event)"
  [url]="kycPreviewUrl"
  [fileName]="kycPreviewFileName"
/>

@if (selectedDealForWithdrawInterest(); as wdeal) {
  
  <app-not-interested-dialog
    [visible]="showWithdrawInterestDialog()"
    (visibleChange)="onWithdrawInterestDialogVisibleChange($event)"
    [clientDealId]="wdeal.clientDealId"
    [dealId]="wdeal.id"
    [dealName]="wdeal.title"
    [header]="'GENERIC.DEAL_ACTION.WITHDRAW_INTEREST' | translate"
    (onSubmitSuccess)="onClientWithdrawInterestSuccess()"
  />
}

<!-- <div class="grid grid-cols-12 gap-8 border border-red-500">
  <app-rm-stats-widget class="contents" />
  <div class="col-span-12 xl:col-span-6">
    <div class="card mb-8!">
      <div class="font-semibold text-xl mb-4">Investments</div>
      <p-chart type="line" [data]="lineData" [options]="lineOptions"></p-chart>
    </div>

    <app-best-selling-widget />

    <div class="card">
      <div class="font-semibold text-xl  mb-8!">Applicant type</div>
      <p-chart type="bar" [data]="barData" [options]="barOptions"></p-chart>
    </div>
  </div>

  <div class="col-span-12 xl:col-span-6">
    <app-revenue-stream-widget />

    <div class="card flex flex-col items-center  mb-8!">
      <div class="font-semibold text-xl mb-4">Wealth Managers Onboard status</div>
      <p-chart type="pie" [data]="pieData" [options]="pieOptions"></p-chart>
    </div>

    <app-notifications-widget />
  </div>
</div> -->
